exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".primary-btn{color:#fff!important;background:#eb102f!important}", ""]);

// exports
